import React, { useEffect, useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';

export default function Alert({show, setShow, title, message, closeAction}: any) { 
  return (
    <>
      <MDBModal open={show} tabIndex='-1' style={show?{opacity: 1, display: 'flex'}:{opacity: 0, display: 'none'}}>
        <MDBModalDialog style={{transform:"translate(0, 0vh)", margin: "auto"}}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{title}</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={()=>closeAction()}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>{message}</MDBModalBody>

            <MDBModalFooter style={{justifyContent: 'space-evenly'}}>
              <MDBBtn color='secondary' onClick={()=>{closeAction()}}>
                Cerrar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}